<template>
  <router-link v-if="to" :to="to"> 승인 </router-link>
  <span v-else :class="request.status" class="font-weight-black">
    {{ request.status | code('LoansRequest.Status') }}
  </span>
</template>

<script>
export default {
  props: ['request'],
  data() {
    return {
      to: null,
    }
  },
  watch: {
    'request.status': {
      async handler(v) {
        if (v === 'approve') {
          const { data } = await this.$defaultApi.getLoansRequestLoan(this.request.uuid)
          if (data?.uuid) {
            this.to = { name: 'loan/detail', params: { uuid: data.uuid } }
          }
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.init {
}
.approve {
  color: $primary;
}
.reject {
  color: $red;
}
.cancel {
}
</style>
